<template>
  <el-dialog
    class="teacher-editor"
    :visible="courseScheduleEditorVisible"
    @close="closeEditor"
    width="650px"
  >
    <el-form
      :model="courseScheduleForm"
      :rules="rules"
      ref="courseScheduleForm"
      label-width="100px"
      class="course-schdeule-ruleForm"
    >
      <el-form-item label="層級" prop="level">
        <el-radio-group
          v-model="courseScheduleForm.level"
          @change="changeSchoolLevel"
        >
          <el-radio-button label="elementary-school">國小</el-radio-button>
          <el-radio-button label="junior-high-school">國中</el-radio-button>
          <el-radio-button label="high-school">高中</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="校區" prop="location">
        <el-radio-group
          class="location-radio"
          v-model="courseScheduleForm.location"
        >
          <el-radio-button label="nantun">南屯校</el-radio-button>
          <el-radio-button label="west-first">西區校 國⼩部</el-radio-button>
          <el-radio-button label="west-second"
            >西區校 國中部/高中部</el-radio-button
          >
          <el-radio-button label="xitun">西屯校</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="年級" prop="grade">
        <el-select
          class="grade-select"
          v-model="selectGrade"
          @change="handleGradeChange"
          placeholder="請選擇年級"
          no-data-text="請先選擇層級"
        >
          <el-option
            v-for="option in gradeOptions"
            :key="option.text"
            :label="option.text"
            :value="option.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-for="(subjuect, index) in courseScheduleForm.subjects"
        :label="'科目' + (index + 1)"
        :key="subjuect.id"
        :prop="'subjects.' + index + '.value'"
        :rules="{
          required: true,
          message: '請選擇科目',
          trigger: 'blur'
        }"
      >
        <div class="subject-item">
          <el-select
            class="subject-select"
            v-model="subjuect.value"
            placeholder="請選擇科目"
            no-data-text="請先選擇層級"
          >
            <el-option
              v-for="item in subjects"
              :key="item.label"
              :label="item.text"
              :value="item.label"
            >
            </el-option>
          </el-select>
          <el-button
            type="success"
            v-if="index == courseScheduleForm.subjects.length - 1"
            @click.prevent="addSubject"
            >新增+</el-button
          >
          <el-button
            @click.prevent="removeSubject(subjuect)"
            v-if="courseScheduleForm.subjects.length > 1"
            >删除</el-button
          >
        </div>
      </el-form-item>
      <el-form-item label="課程名稱" prop="description">
        <el-input
          class="class-name"
          v-model="courseScheduleForm.description"
        ></el-input>
      </el-form-item>
      <el-form-item
        v-for="(time, index) in courseScheduleForm.class_time"
        :label="'課程時間' + (index + 1)"
        :key="time.id"
        :prop="'class_time.' + index + '.value'"
        :rules="{
          required: true,
          message: '請輸入課程時間',
          trigger: 'blur'
        }"
      >
        <el-input
          class="class-time-input"
          v-model="time.value"
          placeholder="課程時間,ex: 17:00 ~ 18:00"
        ></el-input>
        <el-button
          type="success"
          v-if="index == courseScheduleForm.class_time.length - 1"
          @click.prevent="addClassTime"
          >新增+</el-button
        >
        <el-button
          @click.prevent="removeClassTime(time)"
          v-if="courseScheduleForm.class_time.length > 1"
          >删除</el-button
        >
      </el-form-item>
      <el-form-item label="狀態" prop="status">
        <el-input
          type="textarea"
          class="status-input"
          v-model="courseScheduleForm.status"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeEditor">取 消</el-button>
      <el-button type="primary" @click="confirm">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["courseScheduleEditorVisible", "courseScheduleForm", "isCreate"],
  data() {
    return {
      selectGrade: "",
      rules: {
        level: [{ required: true, message: "請選擇層級", trigger: "blur" }],
        location: [{ required: true, message: "請選擇校區", trigger: "blur" }],
        grade: [{ required: true, message: "請選擇年級", trigger: "blur" }],
        description: [
          { required: true, message: "請輸入名稱", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    subjects() {
      switch (this.courseScheduleForm.level) {
        case "elementary-school":
          return [
            {
              label: "math",
              text: "數學"
            },
            {
              label: "natural",
              text: "自然"
            },
            {
              label: "chinese",
              text: "國文"
            },
            {
              label: "english",
              text: "英文"
            },
            {
              label: "society",
              text: "社會"
            },
            {
              label: "all",
              text: "全科"
            }
          ];
        case "junior-high-school":
          return [
            {
              label: "math",
              text: "數學"
            },
            {
              label: "natural",
              text: "自然"
            },
            {
              label: "chinese",
              text: "國文"
            },
            {
              label: "english",
              text: "英文"
            },
            {
              label: "society",
              text: "社會"
            },
            {
              label: "all",
              text: "全科"
            }
          ];
        case "high-school":
          return [
            {
              label: "chinese",
              text: "國文"
            },
            {
              label: "math",
              text: "數學"
            },
            {
              label: "english",
              text: "英文"
            },
            {
              label: "physical",
              text: "物理"
            },
            { label: "chemistry", text: "化學" },
            { label: "biology", text: "生物" },
            {
              label: "history",
              text: "歷史"
            },
            {
              label: "geography",
              text: "地理"
            },
            {
              label: "citizen",
              text: "公民"
            },
            {
              label: "all",
              text: "全科"
            }
          ];
        default:
          return [];
      }
    },
    gradeOptions() {
      switch (this.courseScheduleForm.level) {
        case "elementary-school":
          return [
            { text: "一年級", value: 1.1 },
            { text: "二年級", value: 1.2 },
            { text: "三年級", value: 3 },
            { text: "四年級", value: 4 },
            { text: "五年級", value: 5 },
            { text: "六年級", value: 6 }
          ];
        case "junior-high-school":
          return [
            { text: "升國一", value: 1 },
            { text: "國一", value: 7 },
            { text: "國二", value: 8 },
            { text: "國三", value: 9 }
          ];
        case "high-school":
          return [
            { text: "升高一", value: 2 },
            { text: "高一", value: 10 },
            { text: "高二", value: 11 },
            { text: "高三", value: 12 }
          ];
        default:
          return [];
      }
    }
  },
  methods: {
    changeSchoolLevel() {
      this.selectGrade = "";
      this.courseScheduleForm.grade = "";
    },
    handleGradeChange(val) {
      this.courseScheduleForm.grade = val;
    },
    confirm() {
      this.$refs["courseScheduleForm"].validate(async valid => {
        if (valid) {
          this.$emit("saveCourseSchedule", this.courseScheduleForm);
        } else {
          return false;
        }
      });
    },
    closeEditor() {
      this.$emit("update:courseScheduleEditorVisible", false);
    },
    addSubject() {
      this.courseScheduleForm.subjects.push({
        value: "",
        id: Date.now()
      });
    },
    removeSubject(item) {
      var index = this.courseScheduleForm.subjects.indexOf(item);
      if (index !== -1) {
        this.courseScheduleForm.subjects.splice(index, 1);
      }
    },
    addClassTime() {
      this.courseScheduleForm.class_time.push({
        value: "",
        id: Date.now()
      });
    },
    removeClassTime(item) {
      var index = this.courseScheduleForm.class_time.indexOf(item);
      if (index !== -1) {
        this.courseScheduleForm.class_time.splice(index, 1);
      }
    }
  },
  created() {
    this.$watch("courseScheduleForm.grade", function(newVal) {
      this.selectGrade = newVal;
    });
  },
  mounted() {},
  components: {}
};
</script>

<style lang="scss" scoped>
.course-schdeule-ruleForm {
  padding-right: 30px;
}

.class-time-input {
  width: 300px;
  margin-right: 10px;
}

.status-input {
  width: 150px;
}

.subject-item {
  .subject-select {
    margin-right: 10px;
  }
}
</style>
